import React, { CSSProperties } from 'react'
import styles from './styles.module.scss'

interface ILoadingSpinner {
  style?: CSSProperties
}
const LoadingSpinner: React.FC<ILoadingSpinner> = ({ style }: ILoadingSpinner) => {
  return (
    <div className={styles.spinner} style={style}>
      <span className={styles.spinnerInner1}></span>
      <span className={styles.spinnerInner2}></span>
      <span className={styles.spinnerInner3}></span>
    </div>
  )
}

export default LoadingSpinner
